import { useRef } from 'react';
import { Box } from '@mui/material';
import ReactSelect from 'react-select';

type Props = {
  error?: any;
  country: any;
  regionList: any;
  regionError?: any;
  setCountry: (e: any) => void;
};

export default function SelectCountry({
  error,
  country,
  regionList,
  setCountry,
  regionError,
}: Props) {
  const selectInputRef1 = useRef<any>();
  const selectInputRef = useRef<any>();
  const checkEmptyCity = error
    ? (Object.keys(error)?.length !== 0 && !country?.city) || regionError
    : null;
  const checkEmptyRegion = error
    ? (Object.keys(error)?.length !== 0 && !country?.region) || regionError
    : null;
  const checkEmptyDistric = error
    ? (Object.keys(error)?.length !== 0 && !country?.district) || regionError
    : null;

  const regions = Array.isArray(regionList) ? regionList : (regionList?.results ?? []);

  const handleSelectRegion = (event: any) => setCountry({ region: event });

  const handleSelectCity = (event: any) => setCountry({ region: country.region, city: event });

  const handleSelectDistrict = (event: any) => setCountry({ ...country, district: event });

  const handleKeyDown = (e: any) => {
    if (e.key === 'Escape') {
      return;
    }
  };

  return (
    <Box>
      <Box display='flex' alignItems='center'>
        <Box width='33.3%' mt='5px' overflow='hidden'>
          <ReactSelect
            value={country?.region || null}
            options={regions.map((i: any) => ({
              label: i.name,
              value: i.id,
            }))}
            menuPosition='fixed'
            onKeyDown={handleKeyDown}
            onChange={handleSelectRegion}
            placeholder='Регион'
            isClearable
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                border: checkEmptyRegion ? '1px solid red' : '1px solid #C0C0C0',
              }),
            }}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </Box>
        <Box width='33.3%' mt='5px' overflow='hidden'>
          <ReactSelect
            ref={selectInputRef}
            value={country?.city || null}
            options={regions
              .find((i: any) => i.id === country?.region?.value)
              ?.cities?.map((i: any) => ({
                label: i.name,
                value: i.id,
              }))}
            menuPosition='fixed'
            isDisabled={Boolean(!country?.region)}
            onKeyDown={handleKeyDown}
            onChange={handleSelectCity}
            placeholder='Город'
            isClearable
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                border: checkEmptyCity ? '1px solid red' : '1px solid #C0C0C0',
              }),
            }}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </Box>
        <Box width='33.3%' mt='5px' overflow='hidden'>
          <ReactSelect
            ref={selectInputRef1}
            value={country?.district || null}
            options={regions
              .find((i: any) => i.id === country?.region?.value)
              ?.cities?.find((i: any) => i?.id === country?.city?.value)
              ?.districts?.map((i: any) => ({
                label: i.name,
                value: i.id,
              }))}
            menuPosition='fixed'
            isDisabled={Boolean(!country?.city)}
            onKeyDown={handleKeyDown}
            onChange={handleSelectDistrict}
            placeholder='Район'
            isClearable
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                border: checkEmptyDistric ? '1px solid red' : '1px solid #C0C0C0',
              }),
            }}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </Box>
      </Box>
      <small style={{ color: 'red', fontSize: '12px' }}>
        {(checkEmptyRegion || checkEmptyCity || checkEmptyDistric) &&
          `Поле, обязательное для заполнения`}
      </small>
    </Box>
  );
}
